import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../lib/api";
import { fmtEUR, fmtDate } from "../../lib/format";
import { Card } from "../ui/card";
import { Badge } from "../ui/badge";
import { Button } from "../ui/button";
import { AlertTriangle, Wrench, CalendarClock, ExternalLink } from "lucide-react";

const COL = { nuovo: "bg-sky-500", assegnato: "bg-indigo-500", appuntamento: "bg-amber-500", in_lavorazione: "bg-orange-600", risolto: "bg-emerald-600", chiuso: "bg-slate-500" };

export const OperationTickets = ({ operationId }) => {
  const nav = useNavigate();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/tickets", { params: { operation_id: operationId } }).then((r) => setD(r.data)).catch(() => setD({ items: [] })); }, [operationId]);
  const items = d?.items || [];
  const aperti = items.filter((t) => !["risolto", "chiuso"].includes(t.stato));
  const costi = items.reduce((s, t) => s + (t.costo || 0), 0);
  return (
    <div className="space-y-3" data-testid="op-tickets">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="flex gap-2 text-sm">
          <Badge variant="outline" data-testid="op-tickets-kpi">{aperti.length} aperti · {items.length} totali · costi {fmtEUR(costi)}</Badge>
        </div>
        <Button size="sm" variant="outline" onClick={() => nav(`/assistenza?operation_id=${operationId}`)} data-testid="op-tickets-goto"><ExternalLink className="mr-1 h-4 w-4" />Apri Assistenza post-vendita</Button>
      </div>
      <Card className="divide-y">
        {items.map((t) => (
          <button key={t.id} onClick={() => nav(`/assistenza?ticket=${t.id}`)} className="flex w-full flex-wrap items-center gap-2 p-3 text-left text-sm hover:bg-muted/50" data-testid={`op-ticket-${t.id}`}>
            <Badge className={`${COL[t.stato]} text-white`}>{t.stato_label}</Badge>
            <span className="text-xs text-muted-foreground">{t.codice}</span>
            <span className="font-medium">{t.titolo}</span>
            <span className="text-xs text-muted-foreground">· {t.unita || "appartamento da abbinare"} · {t.cliente || "cliente ?"}</span>
            <span className="ml-auto flex items-center gap-3 text-xs text-muted-foreground">
              {t.appuntamento && <span className="flex items-center gap-1"><CalendarClock className="h-3 w-3" />{fmtDate(t.appuntamento)}</span>}
              {t.fornitore && <span className="flex items-center gap-1"><Wrench className="h-3 w-3" />{t.fornitore}</span>}
              {t.costo ? <span>{fmtEUR(t.costo)}</span> : null}
              {t.attenzione && <span className="flex items-center gap-1 text-rose-600"><AlertTriangle className="h-3 w-3" />{t.attenzione}</span>}
            </span>
          </button>
        ))}
        {!items.length && <div className="p-6 text-center text-sm text-muted-foreground">Nessuna segnalazione post-vendita per questa operazione</div>}
      </Card>
    </div>
  );
};
